import React, {useEffect, useState} from 'react';

import {KBTreeEditItemStructure} from 'app/kbs/components/KBEditPage/KBTree/KBTreeEditItemStructure';
import {useCreateLane} from 'app/lanes/api';
import {gt} from 'app/utils/i18n';

type Props = {
  show: boolean;
  onCancel: () => unknown;
};

export function CreateLaneListItem({show, onCancel}: Props) {
  if (!show) {
    return null;
  }

  const [createLane, {isSuccess}] = useCreateLane();

  const [name, setName] = useState<string>('');

  useEffect(() => {
    if (isSuccess) {
      onCancel();
    }
  }, [isSuccess]);

  return (
    <KBTreeEditItemStructure
      onCancel={onCancel}
      onSubmit={() => createLane({name}).unwrap()}
      className="align-items-center row"
    >
      {function (isSaving) {
        return (
          <>
            <div className="col-auto px-0">
              <i className="fas fa-road fa-fw col-auto pl-1 pr-0 text-dark font-weight-bold" />
            </div>
            <div className="col pr-0">
              <input
                type="text"
                autoFocus={true}
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={gt('Enter lane name...')}
                readOnly={isSaving}
              />
            </div>
          </>
        );
      }}
    </KBTreeEditItemStructure>
  );
}
